/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'davaXQScdQCKYgHcWUf85p.png': { uri: '/images/davaXQScdQCKYgHcWUf85p.png' },
'jsawTrh5KpTGRR3a23ZSf6.png': { uri: '/images/jsawTrh5KpTGRR3a23ZSf6.png' },
'iz4swUTjBqzwsPm5nA6KS1.png': { uri: '/images/iz4swUTjBqzwsPm5nA6KS1.png' },
'tdE4wdA2pHfXjLFEnMSszz.png': { uri: '/images/tdE4wdA2pHfXjLFEnMSszz.png' },
'a7ytyjdVKUn238RHFnezKJ.png': { uri: '/images/a7ytyjdVKUn238RHFnezKJ.png' },
'n8yn8LjWCprQ2TnrRGrZb3.png': { uri: '/images/n8yn8LjWCprQ2TnrRGrZb3.png' },
'9VXYJdqnSwefztqmgVM48g.png': { uri: '/images/9VXYJdqnSwefztqmgVM48g.png' },
'3uF7ApQXu6vrgNgmwCz8QU.png': { uri: '/images/3uF7ApQXu6vrgNgmwCz8QU.png' },
'44MZpVyaWhSWYuM8cwmGL5.png': { uri: '/images/44MZpVyaWhSWYuM8cwmGL5.png' },
'auFkW4HuqKKAmrqHm9bvPo.png': { uri: '/images/auFkW4HuqKKAmrqHm9bvPo.png' },
'9mgqVwjrmtVAbtZE9VPDJW.png': { uri: '/images/9mgqVwjrmtVAbtZE9VPDJW.png' },
'chYzESzhqMHvxUzj2n8FQQ.png': { uri: '/images/chYzESzhqMHvxUzj2n8FQQ.png' },
'4eYqQN3guBDQXfPJhbuVP8.png': { uri: '/images/4eYqQN3guBDQXfPJhbuVP8.png' },
'mnaV5m8DqR5Ser4UmQVDfT.png': { uri: '/images/mnaV5m8DqR5Ser4UmQVDfT.png' },
'dPHnVDTJTopRzpjy8tdMbG.png': { uri: '/images/dPHnVDTJTopRzpjy8tdMbG.png' },
'jq3FmM3D2GeRcQGSTJ1xPf.png': { uri: '/images/jq3FmM3D2GeRcQGSTJ1xPf.png' },
'nE4UXFifgNqVYXU6gXqGaH.png': { uri: '/images/nE4UXFifgNqVYXU6gXqGaH.png' },
'rS3c6Cva4jR7EDtVhuhvhG.png': { uri: '/images/rS3c6Cva4jR7EDtVhuhvhG.png' },
'6LCgNV8XKi5cD8QQKwqxJA.png': { uri: '/images/6LCgNV8XKi5cD8QQKwqxJA.png' },
'w3SCN3uNp1rVvswJBJiyGQ.png': { uri: '/images/w3SCN3uNp1rVvswJBJiyGQ.png' },
'j453HR29jD8axP4qwf42Xh.png': { uri: '/images/j453HR29jD8axP4qwf42Xh.png' },
'b3mPH8LpeAFeuEQD1SBmyR.png': { uri: '/images/b3mPH8LpeAFeuEQD1SBmyR.png' },
'5BLjAUYQzdwGLLGEJ6qqoP.png': { uri: '/images/5BLjAUYQzdwGLLGEJ6qqoP.png' },
'3gCqV1Jgd5mJFLTfG38rcJ.png': { uri: '/images/3gCqV1Jgd5mJFLTfG38rcJ.png' },
'gHSBkNwaTUxouQ8JKK6TMu.png': { uri: '/images/gHSBkNwaTUxouQ8JKK6TMu.png' },
'g3KFhKAA5vsToY8kKfipJA.png': { uri: '/images/g3KFhKAA5vsToY8kKfipJA.png' },
'9DhXSxxC6vxTmqQJMKGbw5.png': { uri: '/images/9DhXSxxC6vxTmqQJMKGbw5.png' },
'nCVJwqetVe4kGvEoFwKBcK.png': { uri: '/images/nCVJwqetVe4kGvEoFwKBcK.png' },
'ukJMnx62vEKSTArFR2jZUJ.png': { uri: '/images/ukJMnx62vEKSTArFR2jZUJ.png' },
'2VVsd5qtXm675EX1Rsn8KU.png': { uri: '/images/2VVsd5qtXm675EX1Rsn8KU.png' },
'dV4WzaApzDfY6PVoWRFs9b.png': { uri: '/images/dV4WzaApzDfY6PVoWRFs9b.png' }
}

export default imageStaticSourcesByFileName
